export enum TechnicalInterventionHistoryItemEntityType {
  TECHNICAL_INTERVENTION = 'technicalIntervention',
}

export enum TechnicalInterventionHistoryItemAction {
  CREATE = 'CreateTechnicalInterventionCommand',
  RE_SCHEDULE = 'ReScheduleTechnicalInterventionCommand',
  CANCEL = 'CancelTechnicalInterventionCommand',
  STATUS_UPDATE = 'TechnicalInterventionStatusUpdatedNotification',
}

export enum TechnicalInterventionHistorySupportedFields {
  START_TIME_UTC = 'StartTimeUtc',
  END_TIME_UTC = 'EndTimeUtc',
  STATUS = 'Status',
}

export interface TechnicalInterventionHistoryItem {
  date: Date;
  entityType: TechnicalInterventionHistoryItemEntityType;
  entityId: string;
  action: TechnicalInterventionHistoryItemAction;
  field: TechnicalInterventionHistorySupportedFields;
  originalValue?: string;
  newValue?: string;
  user: string;
}
